import React from 'react';
import SnippetMeta from '@/Pages/Files/Partials/SnippetMeta';
import useTypedPage from '@/Hooks/useTypedPage';
import MD from '@/Components/MD';
import { cn } from '@/utils';

export interface FileViewerProps {
  file: App.Data.FileData;
  editting?: boolean;
  onMetaSave?: () => void;
}

export function FileViewer(props: FileViewerProps) {
  const { markdown, file } = useTypedPage<{
    markdown: string;
    file: App.Data.FileData;
  }>().props;
  return (
    <div className={cn(
      "pr-8 pl-2 py-6",
      "md:pl-8"
    )}>
      <SnippetMeta {...props} />
      {file.content && <MD markdown={markdown} />}
    </div>
  );
}
